import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorCodes } from '../constants/ErrorCodes';
import { NotificationToastComponent } from '../shared-components/notification-toast/notification-toast.component';


@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  durations = {
    'error': 5000,
    'success': 2000,
    'warn': 5000,
    'info': 5000,
  }

  constructor(private snackBar: MatSnackBar) {
  }

  /**
   * Opens a notification toast with the given text and type.
   * @param text
   * @param type 'error' | 'success' | 'warn' | 'info'
   * @param duration The duration in milliseconds. If 0, the notification will not disappear until dismissed manually. Default is based on error type.
   */
  open(text: string, type: 'error' | 'success' | 'warn' | 'info', duration = this.durations[type]) {
    this.snackBar.openFromComponent(NotificationToastComponent, {
      horizontalPosition: 'right',
      verticalPosition: 'top',
      duration: duration === 0 ? undefined : duration,
      data: {message: text, notificationType: type},
    });
  }

  getErrorByCode(code: string): string {
    switch (code) {
      case "DuplicateUserException": return ErrorCodes.DUPLICATE_USER;
      case "UniqueValueExistsException": return ErrorCodes.DESCRIPCION_CODIGO_EXISTS;
      case "DuplicateSolicitanteException": return ErrorCodes.DUPLICATE_SOLICITANTE;
      case "DuplicateCaiException": return ErrorCodes.DUPLICATE_CAI;
      case "OverlappingCaiException": return ErrorCodes.OVERLAPPING_CAI;
      case "CAI_INACTIVE": return ErrorCodes.CAI_INACTIVE;
      case "DOCK_INACTIVE": return ErrorCodes.DOCK_INACTIVE;
      case "MOTIVO_INACTIVE": return ErrorCodes.MOTIVO_INACTIVE;
      case "DESTINATARIO_INACTIVE": return ErrorCodes.DESTINATARIO_INACTIVE;
      case "TRANSPORTE_INACTIVE": return ErrorCodes.TRANSPORTE_INACTIVE;
      case "DESTINATARIO_TRANSPORTE_INACTIVE": return ErrorCodes.DESTINATARIO_TRANSPORTE_INACTIVE;
      case "DESTINATARIO_CAI_INACTIVE": return ErrorCodes.DESTINATARIO_CAI_INACTIVE;
      case "DESTINATARIO_DOCK_INACTIVE": return ErrorCodes.DESTINATARIO_DOCK_INACTIVE;
      case "TRANSPORTE_CAI_INACTIVE": return ErrorCodes.TRANSPORTE_CAI_INACTIVE;
      case "TRANSPORTE_DOCK_INACTIVE": return ErrorCodes.TRANSPORTE_DOCK_INACTIVE;
      case "DOCK_CAI_INACTIVE": return ErrorCodes.DOCK_CAI_INACTIVE;
      case "ALL_MASTER_INACTIVE": return ErrorCodes.ALL_MASTER_INACTIVE;
      case "ALL_MASTER__NO_CAI_INACTIVE":return ErrorCodes.ALL_MASTER__NO_CAI_INACTIVE;
      case "DESTINATARIO_SOLICITANTE_MOTIVO_INACTIVE": return ErrorCodes.DESTINATARIO_SOLICITANTE_MOTIVO_INACTIVE;
      case "DESTINATARIO_TRANSPORTE_MOTIVO_INACTIVE": return ErrorCodes.DESTINATARIO_TRANSPORTE_MOTIVO_INACTIVE;
      case "DESTINATARIO_TRANSPORTE_DOCK_INACTIVE": return ErrorCodes.DESTINATARIO_TRANSPORTE_DOCK_INACTIVE;
      case "TRANSPORTE_SOLICITANTE_MOTIVO_INACTIVE": return ErrorCodes.TRANSPORTE_SOLICITANTE_MOTIVO_INACTIVE;
      case "MOTIVO_TRANSPORTE_INACTIVE": return ErrorCodes.MOTIVO_TRANSPORTE_INACTIVE;
      case "SOLICITANTE_TRANSPORTE_INACTIVE": return ErrorCodes.SOLICITANTE_TRANSPORTE_INACTIVE;
      case "DESTINATARIO_SOLICITANTE_INACTIVE": return ErrorCodes.DESTINATARIO_SOLICITANTE_INACTIVE;
      case "SOLICITANTE_MOTIVO_INACTIVE": return ErrorCodes.SOLICITANTE_MOTIVO_INACTIVE;
      case "SOLICITANTE_CAI_INACTIVE": return ErrorCodes.SOLICITANTE_CAI_INACTIVE;
      case "DESTINATARIO_MOTIVO_INACTIVE": return ErrorCodes.DESTINATARIO_MOTIVO_INACTIVE;
      case "BLOCKED_REMITO": return ErrorCodes.BLOCKED_REMITO;
      case "SOLICITANTE_INACTIVE": return ErrorCodes.SOLICITANTE_INACTIVE;
      case "ALMACEN_INACTIVE": return ErrorCodes.ALMACEN_INACTIVE;
      case "INVALID_CAI": return ErrorCodes.INVALID_CAI;
      case "MASTER_DATA_INACTIVE": return ErrorCodes.MASTER_DATA_INACTIVE;
      case "DUPLICATE_DESTINATARIO": return ErrorCodes.DUPLICATE_DESTINATARIO;
      case "DUPLICATE_TRANSP": return ErrorCodes.DUPLICATE_TRANSP;
      case "DOCK_FAILED": return ErrorCodes.DOCK_FAILED;
      case "DUPLICATE_BALANZA": return ErrorCodes.DUPLICATE_BALANZA;
      case "DUPLICATE_TPRE": return ErrorCodes.DUPLICATE_TPRE;
      case "VIN_NOT_FOUND": return ErrorCodes.VIN_NOT_FOUND;
      case "ORIGEN_FAILED": return ErrorCodes.ORIGEN_FAILED;
      case "NoSuchKey" : return ErrorCodes.PDF_NOT_FOUND;
      case "EMAIL_ERROR" : return ErrorCodes.EMAIL_ERROR;

      // this will now find a matching error by matching name rather than having to be manually mapped
      default: return ErrorCodes[code as keyof typeof ErrorCodes] ?? ErrorCodes.UNKNOWN_ERROR;
    }
  }
}
